import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Space, Button, Modal, Input, Form, Radio  } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { notify } from '../../../lib/toasts'
import { gray5 } from '../../../constants/Colors'

import { useUpdateGroup, useCreateGroup } from '../api/Groups';

const StyledButton = styled(Button)`
  width: 100%;
  justify-content: center;
  font-weight: 600;
`;

const StyledForm = styled(Form)`
  .ant-form-item-label {
    font-weight: 600;
  }
`

const StyledSpace = styled(Space)`
  padding: 20px 0 5px 0;
`

const StyledDescription = styled.div`
  color: ${gray5}; 
  font-style: italic;
`;

function GroupFormModal({
  group = {},
  isOpen = false,
  onClose,
  submitText = 'Save'
}) {

  const [form, setForm] = useState({ ...group });
  const navigate = useNavigate();
  const updateGroup = useUpdateGroup();
  const createGroup = useCreateGroup();


  useEffect(() => {

    if(group && group.identifier) {
      setForm(group);
    }

  }, [isOpen == true])


  const handleChange = (field, value) => {

    let nextValue = value;
    if (field === 'identifier') nextValue = value.replace(/\W/g, '')

    const nextForm = {...form, [field]: nextValue};

    setForm(nextForm);

  }

  const handleSubmit = () => {

    if (group.identifier) {

      updateGroup.mutate(
        { identifier: group.identifier, payload: { title: form.title } },
        {
          onSuccess: (data) => {
            notify.success('Success');
            handleClose()
          },
          onError: () => {
            notify.error('Oops.. update failed');
            handleClose()
          },
        }
      ) 

    } else {

      createGroup.mutate(
        { ...form },
        {
          onSuccess: (data) => {
            notify.success('Success');
            navigate(`/groups/${data.identifier}`);
          },
          onError: () => {
            notify.error('Oops.. create failed');
          },
        }
      ) 

    }

  }

  const handleClose = () => {
    setForm({});
    onClose();
  }



  return (
    <Modal
      title="Group Settings"
      open={isOpen}
      footer={[
        <StyledButton type="primary" onClick={handleSubmit}>
          {submitText} 
        </StyledButton>
      ]}
      onCancel={handleClose}
    >
      <StyledSpace 
        direction="vertical"
        size="middle"
      >
        <StyledForm
          layout="vertical"
          size="large"
        >
          <StyledForm.Item label="Title">
            <Input 
              placeholder="Company A" 
              value={form.title}
              onChange={(e) => handleChange('title', e.target.value)}
            />
          </StyledForm.Item>
          <StyledForm.Item label={group.identifier ? 'Identifier' : 'Identifier (optional)'}>
            <Input 
              disabled={group.identifier}
              placeholder="group_xxxxxxxxxx" 
              value={form.identifier}
              onChange={(e) => handleChange('identifier', e.target.value)}
            />
            <StyledDescription>Only 1-9, a-z and _ characters supported for identifier. Identifiers must be atleast three characters long. Leave blank to have auto-generated by Joyfill. </StyledDescription>
          </StyledForm.Item>
        </StyledForm>
      </StyledSpace>
    </Modal>
  );
};

export default GroupFormModal;
